import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const CREATE_AGENCY = gql`
  mutation createAgency($data: CreateAgencyInput!) {
    createAgency(data: $data) {
      status
      message
    }
  }
`;

export const UPDATE_AGENCY = gql`
  mutation updateAgency($id: ID!, $data: UpdateAgencyInput!) {
    updateAgency(id: $id, data: $data) {
      status
      message
    }
  }
`;

export const DELETE_AGENCY = gql`
  mutation deleteAgency($where: AgencyInput!) {
    deleteAgency(where: $where) {
      assignedAsApprover
      status
      message
    }
  }
`;
export const DELETE_AGENCY_USER = gql`
  mutation deleteAgencyUser($where: AgencyUserInput!) {
    deleteAgencyUser(where: $where) {
      status
      message
      assignedAsApprover
    }
  }
`;

export const CREATE_AGENCY_CONTACT = gql`
  mutation createUser($data: CreateUserInput!) {
    createUser(data: $data) {
      user {
        id
        name
        email
        phoneNo
        isActive
        isUserExistWithSameEmailAndPhone
      }
      status
      message
    }
  }
`;

export const IMPORT_AGENCY_CSV = gql`
  mutation importAgencyCsv($key: String!) {
    importAgencyCsv(key: $key) {
      insertedData
      invalidData
      insertedDataCount
      invalidDataCount
    }
  }
`;
